import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { injectStripe } from 'react-stripe-elements';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';
import values from 'lodash/values';
import isEmptyObject from 'lodash/isEmpty';
import { isEngagementValid, dayIsInPast } from '../../shared/utils';
import { getActiveUser } from '../../shared/redux/selectors';

import {
  loadCampaign,
  loadBrand,
  loadAgency,
  updateAgency,
  loadPaymentMethodsForAgency,
  updateCampaign,
  loadEngagementsForCampaign,
  submitCampaign,
  loadAgencyWithChildren,
  createPaymentMethod
} from '../../shared/redux/entities/actions';

import {
  loadAccountHistory
} from '../../shared/redux/accounting/actions';

function getBrandsForAgency(state,agencyId){
  const brands = values(state.entities.companies).filter((c) => c.isBrand);

  if(agencyId){
    return brands.filter((b) => b.agencyId === agencyId);
  } else {
    return brands;
  }
}

function getEngagementsForCampaign(state,campaignId){
  if(campaignId){
    return values(state.entities.engagements)
      .filter((e) => e.campaignId === campaignId)
      .sort((a,b) => a.ordinal - b.ordinal);

  } else {
    return [];
  }
}

function getInvalidEngagementIndexes(state,campaignId){
  const engagements = getEngagementsForCampaign(state,campaignId);
  return engagements.reduce((invalids,e,index) => {
    if(!isEngagementValid(e)){
      return invalids.concat(index)
    } else{
      return invalids
    }
  },[]);
}

function getNextOrdinal(state,campaignId){
  const engagements = getEngagementsForCampaign(state,campaignId);

  if(engagements.length === 0){
    return 0;
  } else {
    return engagements[engagements.length - 1].ordinal + 1;
  }
}

function areAllRequiredFieldsFilled(state,campaignId){
  const activeCampaign = get(state,['entities','campaigns',campaignId],null);

  if(!activeCampaign) return false;

  return (activeCampaign.feedImageURL || '').length > 0
    && activeCampaign.completionText && activeCampaign.completionText.replace(/<\/?[^>]+(>|$)/g, "").trim().length > 0
    && activeCampaign.name.length > 0
    && activeCampaign.launchDate
    && !dayIsInPast(activeCampaign.endDate);
}

function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId);

  } else {
    return [];
  }
}

function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
    activeCampaign = get(state,['entities','campaigns',campaignId],{}),
    activeUser = getActiveUser(state);
  const ios = values(get(state,['entities','ios'],[])).filter(io => io.accountId === activeCampaign.agencyId && io.state === 'ACTIVE')
      .sort((a,b) => b.createdDate - a.createdDate);
  return {
    campaignId:campaignId,
    isCreate:campaignId === 'new',
    IsActiveUserProvider:get(activeUser,['isProvider'],true),
    needsActiveUser:activeUser === null,
    agencies:values(state.entities.agencies),
    brands:getBrandsForAgency(state,activeCampaign.agencyId),
    activeUser:activeUser,
    activeCampaign:activeCampaign,
    activeAgency:get(state,['entities','agencies',activeCampaign.agencyId],{}),
    activeBrand:get(state,['entities','companies',activeCampaign.companyId],{}),
    activeEngagements:getEngagementsForCampaign(state,activeCampaign.id),
    nextOrdinal:getNextOrdinal(state,activeCampaign.id),
    activePaymentMethod:get(state,['entities','paymentMethods',activeCampaign.paymentMethodId],{}),
    activePaymentMethods:getPaymentMethodsForAgency(state,activeCampaign.agencyId),
    invalidEngagementIndexes:getInvalidEngagementIndexes(state,activeCampaign.id),
    allRequiredFieldsAreFilled:areAllRequiredFieldsFilled(state,activeCampaign.id),
    activeUserHasSeenTutorial: isEmptyObject(activeUser) ? true : get(activeUser,['hasSeenCampaignIntro'],false),
    agencyAccountingBalance:get(state,['accounting','accounts',activeCampaign.agencyId,'balance']),
    activeUserId:activeUser.id,
    ios:ios
  };
}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createPaymentMethod,
    loadCampaign,
    loadAgency,
    loadEngagementsForCampaign,
    submitCampaign,
    loadBrand,
    updateCampaign,
    updateAgency,
    loadPaymentMethodsForAgency,
    loadAgencyWithChildren,
    loadAccountHistory
  },dispatch);
}

export default compose(
  injectStripe,
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignPayment/connect.js